import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-footer-2',
    templateUrl: './footer-2.component.html',
    styleUrls: ['./footer-2.component.scss']
})
export class FooterTwoComponent implements OnInit {

    constructor(
        public router: Router
    ) { }

    ngOnInit() {}

}